import { useClubContext } from "../../context/ClubContext";
import { useConfigContext } from "../../context/ConfigContext";
import { useLabelsContext } from "../../context/LabelsContext";
import { getISO3LangCode } from "../../utils/helpers";

export const JoinFree: React.FC = () => {
	const { labels } = useLabelsContext();
	const { config } = useConfigContext();
	const { club } = useClubContext();

	return (
		<span
			dangerouslySetInnerHTML={{
				__html:
					labels?.["JoinFree"]?.replace(
						"{0}",
						`${club?.bookingDomain}be/club/register?chainId=${config?.chainId}&lang=${getISO3LangCode(config?.language)}`,
					) || "",
			}}
		></span>
	);
};
